import cloneDeep from "lodash.clonedeep";
import { v4 } from "uuid";

import {
  DiscountTierDto,
  DiscountUnitType,
  OfferDto,
  OfferTierUnitFieldType,
} from "@intelligems/ig-types";

import { DISCOUNT_MAX_UNITS } from "@intelligems/ig-types";

export const recalculateUnitQuantities = (
  unitType: DiscountUnitType,
  _tiers: DiscountTierDto[],
  tierIndex: number
) => {
  const tiers = cloneDeep(_tiers);
  for (let i = 0; i < tiers.length; i++) {
    if (i === 0 && tiers.length > 1) {
      tiers[i].maximumUnits =
        tiers[i + 1].minimumUnits - (unitType === "dollar" ? 0.01 : 1);
    }

    if (i > 0 && i > tierIndex) {
      if (tiers[i].minimumUnits <= tiers[i - 1].maximumUnits) {
        tiers[i].minimumUnits =
          tiers[i - 1].maximumUnits + (unitType === "dollar" ? 0.01 : 1);
      }
    }

    if (i > 0 && i < tiers.length - 1) {
      tiers[i].maximumUnits =
        tiers[i + 1].minimumUnits - (unitType === "dollar" ? 0.01 : 1);
    }

    if (tiers[i].maximumUnits < tiers[i].minimumUnits) {
      tiers[i].maximumUnits =
        unitType === "dollar"
          ? tiers[i].minimumUnits + 0.99
          : tiers[i].minimumUnits;
    }

    if (i === tiers.length - 1) {
      tiers[i].maximumUnits = DISCOUNT_MAX_UNITS;
    }
  }
  return tiers;
};

export const resetUnitQuantities = (tiers: DiscountTierDto[]) => {
  return tiers.map((tier, index) => {
    tier.minimumUnits = index;
    if (index === tiers.length - 1) {
      tier.maximumUnits = DISCOUNT_MAX_UNITS;
    } else {
      tier.maximumUnits = index;
    }
    return tier;
  });
};

export const addTier = <T extends OfferDto>(draft: T): T => {
  if (draft.tiers[draft.tiers.length - 1].maximumUnits === DISCOUNT_MAX_UNITS) {
    draft.tiers[draft.tiers.length - 1].maximumUnits =
      draft.unitType === "unit"
        ? draft.tiers[draft.tiers.length - 1].minimumUnits + 1
        : draft.tiers[draft.tiers.length - 1].minimumUnits + 0.99;
  }

  draft.tiers.push({
    id: v4(),
    minimumUnits:
      draft.unitType === "unit"
        ? draft.tiers[draft.tiers.length - 1].maximumUnits + 1
        : draft.tiers[draft.tiers.length - 1].maximumUnits + 0.01,
    maximumUnits: DISCOUNT_MAX_UNITS,
    unitDiscount: 0,
    bxgyGetQuantity: 0,
    discountTitle: null,
    giftWithPurchaseTitle: null,
    isFreeShipping: draft.tiers[draft.tiers.length - 1].isFreeShipping,
    isGiftWithPurchase: false,
    giftWithPurchaseVariantIds: [],
    autoAddGiftWithPurchase: true,
  });

  return draft;
};

export const removeTier = <T extends OfferDto>(
  draft: T,
  tierIndex: number
): T => {
  draft.tiers.splice(tierIndex, 1);
  draft.tiers = recalculateUnitQuantities(draft.unitType, draft.tiers, 0);

  return draft;
};

export const setUnit = <T extends OfferDto>(
  draft: T,
  key: OfferTierUnitFieldType,
  tierIndex: number,
  value: number
): T => {
  draft.tiers[tierIndex][key] = value;

  if (key === "minimumUnits") {
    draft.tiers = recalculateUnitQuantities(
      draft.unitType,
      draft.tiers,
      tierIndex
    );
  }

  return draft;
};

export const toggleDiscountUnitType = <T extends OfferDto>(
  draft: T,
  payload: { value: string }
): T => {
  draft.unitType = payload.value as DiscountUnitType;
  draft.tiers = resetUnitQuantities(draft.tiers);

  return draft;
};
